module.exports = __webpack_public_path__ + "static/img/cangku2.a1f44d11.png";